export * from './extra-vereinbarung-entfernt.interface';
